import React from "react";

function DropInput({
  name,
  className,
  label,
  onChange,
  value,
  required,
  isDisable,
  errors,
  errormessage,
  option,
}: any) {
  return (
    <div className="flex flex-col items-start gap-1.5 w-full my-1.5">
      <label htmlFor={name} className={`block text-sm font-normal capitalize text-slate-700 dark:text-slate-300 ${className || ""}`}>
        {label}
      </label>
      <select
        id={name}
        onChange={onChange}
        value={value}
        required={required ?? false}
        disabled={isDisable}
        name={name}
        className={`w-full h-10 px-3 rounded-md border bg-slate-50 dark:bg-slate-700 text-slate-800 dark:text-slate-200 text-sm outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent disabled:opacity-60 disabled:cursor-not-allowed ${
          errors ? "border-red-500" : "border-slate-300 dark:border-slate-600"
        }`}
      >
        <option value="">Select an option</option>
        {option?.map((item: any, index: number) => (
          <option key={index} value={item?.value ?? item?.name}>
            {item?.name}
          </option>
        ))}
      </select>
      {errors && (
        <label className="text-red-500 text-[13px] font-normal">
          {errormessage ? errormessage : `${label ? label : "this field"} is mandatory`}
        </label>
      )}
    </div>
  );
}

export default DropInput;
